const ZOOM_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const ZOOM_MONTH_RE = /^(\d{4})-(\d{2})$/;

export function parseZoomDateKey(key: string): Date | null {
  if (!ZOOM_DATE_RE.test(key)) return null;
  const [y, m, d] = key.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) {
    return null;
  }
  date.setHours(0, 0, 0, 0);
  return date;
}

export function parseZoomMonthKey(key: string): Date | null {
  const match = key.match(ZOOM_MONTH_RE);
  if (!match) return null;
  const y = Number(match[1]);
  const m = Number(match[2]);
  if (m < 1 || m > 12) return null;
  const date = new Date(y, m - 1, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

export function resolveZoomTargetFromElement(target: EventTarget | null): Date | null {
  if (!(target instanceof Element)) return null;

  const dateEl = target.closest<HTMLElement>('[data-zoom-date]');
  if (dateEl?.dataset.zoomDate) {
    const parsed = parseZoomDateKey(dateEl.dataset.zoomDate);
    if (parsed) return parsed;
  }

  const slotEl = target.closest<HTMLElement>('[data-slot-day]');
  if (slotEl?.dataset.slotDay) {
    const parsed = parseZoomDateKey(slotEl.dataset.slotDay);
    if (parsed) return parsed;
  }

  const monthEl = target.closest<HTMLElement>('[data-zoom-month]');
  if (monthEl?.dataset.zoomMonth) {
    return parseZoomMonthKey(monthEl.dataset.zoomMonth);
  }

  return null;
}

export function resolveZoomTargetAtPoint(x: number, y: number): Date | null {
  if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
  const el = document.elementFromPoint(x, y);
  return resolveZoomTargetFromElement(el);
}
